
import { 
    SAVE_APPEAL_LETTER,
    SAVE_APPEAL_LETTER_SUCCESS,
    SAVE_APPEAL_LETTER_FAIL, 
    SAVE_APPEAL_LETTER_RESET,
} from "../actions/saveAppealLetterAction";

const initialState = {
    apiState: "",
    message: "",
    data: null,
    error: "",
}

const saveAppealLetterReducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_APPEAL_LETTER:
            return {
                ...state,
                apiState: "loading",
            };
        case SAVE_APPEAL_LETTER_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
                message: action.response.message ? action.response.message : "success",
            };
        case SAVE_APPEAL_LETTER_FAIL:
            return {
                ...state,
                apiState: "error",
                error: action.response.errors,
                message: action.response.message ? action.response.message : "error",
            };
        case SAVE_APPEAL_LETTER_RESET:
            return initialState;
        default: 
            return state;
    }
};

export default saveAppealLetterReducer;
